import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { cloneDeep } from 'lodash';
import { ReportTemplate, getReportTemplates } from '../../api/reportTemplate';
import { ReportTemplateSlice, EditReportTemplateSlice } from './types';
import { notUndefined } from '../../lib/typeCheck';

const initialState: ReportTemplateSlice[] = [];

export const reportTemplatesSlice = createSlice({
  name: 'reportTemplates',
  initialState,
  reducers: {
    loadReportTemplates: (state, action: PayloadAction<ReportTemplate[]>) => {
      return action.payload.map((reportTemplate, index) => {
        let combined: any = cloneDeep(reportTemplate);
        combined.report_template_id = combined.id;
        combined.id = index;
        combined.saved = true;
        return combined
      })
    },
    editTemplate: (state, action: PayloadAction<EditReportTemplateSlice>) => {
      const reportTemplate = state.find(reportTemplate => reportTemplate.report_template_id === action.payload.report_template_id);
      if (notUndefined(action.payload.title)) reportTemplate.title = action.payload.title;
    }
  }
});

export const { loadReportTemplates, editTemplate } = reportTemplatesSlice.actions;

export const fetchReportTemplates = (station_id: number): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  try {
    const reportTemplates = await getReportTemplates(user.api_key, station_id)
    
    if (reportTemplates.length > 0) {
      dispatch(loadReportTemplates(reportTemplates));
    }
    
  } catch (err) {
    console.error(err.toString())
  }
}

export const selectAllReportTemplates = (state: RootState) => {
  return state.reportTemplates;
}

export default reportTemplatesSlice.reducer;
